<div class="parent-container" *ngFor="let parent of user?.parents">
  <div class="parent-content">
    <div class="content-left">
      <div class="parent-image">
        <img class="avatar" src="{{ parent.photo }}" alt="avatar" />
      </div>
    </div>

    <div class="content-right">
      <div class="parent-name">
        <span class="parent-name-text title-color">
          {{ parent.fullName }}
        </span>
      </div>
      <div class="parent-profiles"
      *ngFor="let profile of parent?.profiles; index as i">
      <span *ngIf="profile">
        {{ profile }}
      </span>
    </div>
    </div>
  </div>
</div>